import { defineStore } from 'pinia';
import { ref } from 'vue';

interface Notification {
  type: 'success' | 'error' | 'warn' | 'info' | 'secondary';
  message: string;
  title: string;
  life: number;
}

export const useNotificationStore = defineStore('notification', () => {
  const notification = ref<Notification>({
    type: 'success',
    message: 'Success message',
    title: 'Success',
    life: 3000,
  });

  return {
    notification,
  };
});
